<template>
  <div class="tile is-parent pl-1">
    <article class="tile is-child box">
      <div class="columns is-flex is-align-items-center">
        <div class="column">
          <p class="title">Detail Info</p>
        </div>
      </div>
      <div class="field columns">
        <div class="column is-half">
          <label class="label">Username</label>
          <div class="control">
            <input class="input"
              type="text"
              autocomplete="off"
              v-model="value.username"
              :disabled="!value.isNew && isCustomerAdmin"
              :class="{ 'is-danger' : $vv.entity.username.$error }">
            <span class="help is-danger"
              v-if="!$vv.entity.username.required">Username is required
            </span>
            <span class="help is-danger"
              v-if="!$vv.entity.username.isUniqueUsername">This username is already in use.
            </span>
          </div>
        </div>
        <div class="column is-half">
          <label class="label">Email</label>
          <div class="control">
            <input class="input"
              type="text"
              autocomplete="new-email"
              v-model="value.email"
              :class="{ 'is-danger' : $vv.entity.email.$error }">
            <span class="help is-danger"
              v-if="!$vv.entity.email.email">Please enter a valid email
            </span>
            <span class="help is-danger"
              v-if="!$vv.entity.email.required">Email is required
            </span>
            <span class="help is-danger"
              v-if="!$vv.entity.email.isUniqueEmail">This email is already in use.
            </span>
          </div>
        </div>
      </div>
      <div class="field columns"
        v-if="!value.isNew">
        <div class="column is-half pb-0">
          <label class="label">Password</label>
          <button class="button is-primary tooltip"
            data-tooltip="Reset Password"
            @click="toggleResetPasswordModal">
            <span>Reset Password</span>
          </button>
        </div>
      </div>
      <div class="field columns"
        v-else>
        <div class="column is-half">
          <label class="label">Password</label>
          <div class="field has-addons">
            <div class="control  is-expanded">
              <input class="input"
                :type="showPassword ? 'text' : 'password'"
                autocomplete="new-password"
                v-model="value.password"
                :class="!$vv.entity.password.$error ? '' : 'is-danger'"
                @blur="validatePassword(value.password)">
              <span class="help is-danger"
                v-if="!$vv.entity.password.required && value.isNew">Password is required
              </span>
              <span class="help is-danger"
                v-if="!passwordMeetsCriteria">
                {{ passwordMessage }}
              </span>
            </div>
            <p class="control">
              <button class="button"
                @click="showPassword=!showPassword">
                <span class="icon has-text-primary">
                  <span class="mso mso-24px">
                    {{ showPassword ? 'visibility' : 'visibility_off' }}
                  </span>
                </span>
              </button>
            </p>
          </div>
        </div>
        <div class="column is-half">
          <label class="label">Confirm Password</label>
          <div class="field has-addons">
            <div class="control is-expanded">
              <input class="input"
                :type="showConfirmPassword ? 'text' : 'password'"
                v-model="value.confirmNewPassword"
                :class="!$vv.entity.confirmNewPassword.$error ? '' : 'is-danger'">
              <span class="help is-danger"
                v-if="value.password && value.confirmNewPassword && !passwordsMatch && value.isNew">Passwords do not match.</span>
              <span class="help is-danger"
                v-if="!$vv.entity.confirmNewPassword.required && value.isNew">Confirm Password is required
              </span>
            </div>
            <p class="control">
              <button class="button"
                @click="showConfirmPassword=!showConfirmPassword">
                <span class="icon has-text-primary">
                  <span class="mso mso-24px">
                    {{ showConfirmPassword ? 'visibility' : 'visibility_off' }}
                  </span>
                </span>
              </button>
            </p>
          </div>
        </div>
      </div>
      <div class="field columns">
        <div class="column is-half pb-0">
          <label class="label">Status</label>
          <div>
            <div class="pretty p-default p-round p-smooth ">
              <input id="chk-pretty-customer-type"
                v-model="value.active"
                name="chk-pretty-customer-type"
                :value="true"
                type="radio">
              <div class="state p-primary">
                <label>Active</label>
              </div>
            </div>
            <div class="pretty p-default p-round p-smooth">
              <input id="chk-pretty-customer-type"
                v-model="value.active"
                name="chk-pretty-customer-type"
                :value="false"
                type="radio">
              <div class="state p-primary">
                <label>Inactive</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="field columns">
        <div class="column is-half pb-0">
          <label class="label">Roles</label>
          <div :key="rolesKey">
            <div v-for="(role, index) in localRoles"
              :key="index">
              <div class="columns">
                <div class="column">
                  <div class="pretty p-icon p-curve p-smooth m-0 p-bigger">
                    <input type="checkbox"
                      v-model="role.active"
                      @change="validateRoles(role)">
                    <div class="state p-primary">
                      <span class="icon mso">
                        check
                      </span>
                      <label />
                    </div>
                  </div>
                </div>
                <div class="column is-four-fifths">
                  {{ role.label }}
                  <span v-if="role.name === 'CustomerMobile'"
                    class="tag is-info is-light ml-2">
                    Mobile users can only flexiquote mobile app and don't have access to the web app.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <reset-password-modal v-model="value"
        :active="showResetPasswordModal"
        @close="showResetPasswordModal = false" />
    </article>
  </div>
</template>

<script>
// import Guid from '../../components/Guid'
import { UserService } from '../../services'
import ResetPasswordModal from './ResetPasswordModal.vue'

export default {
  name: 'UserDetail',
  inject: ['$vv'],
  components: {
    ResetPasswordModal
  },
  props: {
    value: null, //v-model
    isAllowedAccessNewPwa: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showResetPasswordModal: false,
      localRoles: [],
      originalRoles: [],
      rolesKey: 0,
      emailUniqueError: false,
      usernameUniqueError: false,
      passwordMeetsCriteria: false,
      passwordMessage: '',
      showPassword: false,
      showConfirmPassword: false
    }
  },
  computed: {
    passwordsMatch() {
      return this.value.password === this.value.confirmNewPassword
    },
    AVAILABLE_ROLES() {
      return [
        { name: 'CustomerAdministrators', label: 'Administrators', isShow: !this.$userInfo.isSystemAdministrator || this.$userInfo.isSupportUser },
        { name: 'CustomerUsers', label: 'Users', isShow: !this.$userInfo.isSystemAdministrator || this.$userInfo.isSupportUser },
        { name: 'SupportUsers', label: 'Support Users', isShow: this.$userInfo.isSystemAdministrator && !this.$userInfo.isSupportUser },
        { name: 'Users', label: 'Users', isShow: this.$userInfo.isSystemAdministrator && !this.$userInfo.isSupportUser },
        { name: 'CustomerMobile', label: 'Mobile App Users', isShow: this.isAllowedAccessNewPwa }
      ]
    },
    isCustomerAdmin() {
      const found = (this.value.roles || []).find((r) => r.active && !r.isNew)
      if (!found) {
        return false
      }
      return found.name === 'CustomerAdministrators'
    },
    isMobileAppUser() {
      return this.localRoles.some((role) => role.name === 'CustomerMobile' && role.active)
    },
    $v() {
      return this.$vv ? this.$vv : this.$v
    }
  },
  watch: {
    'value.username'(newUsername) {
      if (this.value && this.value.isNew) {
        if (!this.value.profile) {
          this.$set(this.value, 'profile', {})
        }
        this.value.profile.displayName = newUsername
      }
    },
    'value.email'(newEmail) {
      if (this.value && this.value.isNew) {
        if (!this.value.profile) {
          this.$set(this.value, 'profile', {})
        }
        this.value.profile.assetEmails[0].address = newEmail
      }
    },
    value: {
      handler(val) {
        if (val) {
          this.localRoles = this.AVAILABLE_ROLES.filter((role) => role.isShow).map((role) => {
            const found = (this.value.roles || []).find((r) => r.name === role.name)
            return {
              name: role.name,
              label: role.label,
              ...(found ? { ...found } : { active: false })
            }
          })
          if (this.localRoles.length > 0 && !this.originalRoles.length) {
            this.originalRoles = JSON.parse(JSON.stringify(this.localRoles))
          }
        }
      },
      immediate: true,
      deep: true
    },
    isMobileAppUser: {
      handler(newVal) {
        this.$emit('mobile-app-user-changed', newVal)
      },
      immediate: true
    },
    isAllowedAccessNewPwa: {
      handler(newVal) {
        if (newVal && this.value) {
          this.localRoles = this.AVAILABLE_ROLES.filter((role) => role.isShow).map((role) => {
            const found = (this.value.roles || []).find((r) => r.name === role.name)
            return {
              name: role.name,
              label: role.label,
              ...(found ? { ...found } : { active: false })
            }
          })
          this.rolesKey++
        }
      }
    }
  },
  created() {
    this.originalRoles = JSON.parse(JSON.stringify(this.localRoles))
    // this.checkEmailUnique()
    // this.checkUsernameUnique()
  },
  mounted() {
    this.$on('refreshProfile', (newEntity) => {
      this.innerValue = _cloneDeep(newEntity)
    })

    this.$v.detailGroup.$touch()
  },
  methods: {
    validateRoles(changedRole) {
      if (changedRole.active) {
        this.localRoles.forEach((role) => {
          if (role.name !== changedRole.name) {
            role.active = false
          }
        })
      }

      const activeCount = this.localRoles.filter((r) => r.active).length
      if (activeCount === 0) {
        this.$notification.openNotificationWithType('danger', 'User', 'User must have at least one role!')
        this.localRoles = JSON.parse(JSON.stringify(this.originalRoles))
        this.rolesKey++
        return
      }

      this.localRoles.forEach((role) => {
        const original = this.originalRoles.find((r) => r.name === role.name)
        if (original && original.userRoleId) {
          if (original.active && !role.active) {
            role.isDeleted = true
          } else if (original.active === role.active) {
            role.isDeleted = original.isDeleted
          }
        } else {
          role.isNew = role.active
          role.isDeleted = false
        }
      })

      this.value.roles = [...this.localRoles]
      this.originalRoles = JSON.parse(JSON.stringify(this.localRoles))
      this.$emit('input', this.value)
    },
    toggleResetPasswordModal() {
      this.showResetPasswordModal = !this.showResetPasswordModal
    },
    // async checkEmailUnique() {
    //   this.emailUniqueError = false
    //   if (!this.value.email || !/^\S+@\S+\.\S+$/.test(this.value.email)) {
    //     return
    //   }
    //   const userId = this.value.isNew ? Guid.empty() : this.value.userId
    //   const isUnique = await UserService.checkEmailValidity(this.value.email, userId)
    //   this.emailUniqueError = !isUnique
    // },
    // async checkUsernameUnique() {
    //   this.usernameUniqueError = false
    //   if (!this.value.isNew) return
    //   if (!this.value.username) {
    //     return
    //   }
    //   const isNotUnique = await UserService.checkUsernameValidity(this.value.username)
    //   this.usernameUniqueError = isNotUnique
    // },
    async validatePassword(password) {
      if (!password || password.length === 0) {
        this.passwordMeetsCriteria = false
        this.passwordMessage = ''
        return
      }
      await UserService.getPasswordComplexity(password).then((result) => {
        this.passwordMeetsCriteria = result.passwordMeetsCriteria
        this.passwordMessage = result.message
      })
    }
  },
  beforeRouteLeave: function (to, from, next) {
    next()
  }
}
</script>